export enum SearchType {
  ACD_QUEUE = 'ACD_QUEUE',
  DEDICATED_CONF = 'DEDICATED_CONF',
  DEVICE = 'DEVICE',
  DOMAIN = 'DOMAIN',
  END_USER = 'END_USER',
  IVR_ASSISTANT = 'IVR_ASSISTANT',
}
